import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/page01',
      name: 'page01',
      component: () => import('../view/page01.vue'),
      meta: {
        title: '驿站申请'
      }
    },
    {
      path: '/page02',
      name: 'page02',
      component: () => import('../view/page02.vue'),
      meta: {
        title: '运营中心申请'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js